import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiHome } from 'react-icons/fi';

const Agradecimento = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="bg-sky-50 rounded-lg shadow-xl p-8 md:p-12 text-center">
          {/* Ícone de Sucesso */}
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center">
              <FiCheckCircle className="text-white" size={48} />
            </div>
          </div>

          {/* Mensagem Principal */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Pré-Reserva Enviada com Sucesso!
          </h1>

          <p className="text-lg text-gray-700 mb-6">
            Sua solicitação de pré-reserva foi recebida e está sendo analisada pela nossa equipe.
          </p>

          {/* Informações Importantes */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8">
            <div className="text-left space-y-3">
              <div className="flex items-start gap-3">
                <span className="text-2xl">📞</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Entraremos em contato</h3>
                  <p className="text-sm text-gray-700">
                    Nossa equipe de atendimento entrará em contato através do telefone informado para completar sua reserva e confirmar os detalhes de pagamento.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-2xl">⏰</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Aguarde nosso contato</h3>
                  <p className="text-sm text-gray-700">
                    O atendimento geralmente é realizado em até 24 horas úteis. Por favor, mantenha seu telefone disponível.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-2xl">✅</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Sua solicitação está segura</h3>
                  <p className="text-sm text-gray-700">
                    Todos os dados da sua pré-reserva foram registrados e estão disponíveis para nossa equipe.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Botões de Ação */}
          <div className="flex justify-center">
            <Link
              to="/"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-sky-600 text-white rounded-lg font-semibold hover:bg-sky-700 transition-colors"
            >
              <FiHome size={20} />
              Voltar para o Início
            </Link>
          </div>

          {/* Informações Adicionais */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Precisa de ajuda? Entre em contato conosco através dos nossos canais de atendimento.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agradecimento;
